// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__29q0S","addWidgetButton":"Header_addWidgetButton__vG24s","dashboardTabs":"Header_dashboardTabs__1M-yS","active":"Header_active__2Uoab"};